import type { IModuleDefinition, IModuleStrings, StandardViewKey } from '@platform/core/types';

/** Стандартні подання рушія в порядку перемикача. */
export const standardViews: readonly StandardViewKey[] = ['table', 'stages', 'cards', 'inline', 'backlog', 'split', 'calendar', 'dashboard'];

/** Рядок рушія `views.custom` — повідомлення про окреме подання, а не підпис, тож для ключа 'custom' його не беремо. */
const MESSAGE_KEY = 'custom';

/**
 * Підпис подання (перемикач подань, сторінка налаштувань): власне подання — підпис сторінки модуля з тим самим ключем
 * (рядок пакета pages[ключ] → підпис визначення мовою інтерфейсу); інакше рядок рушія `views.<ключ>`, якщо він є (`platform`),
 * інакше сам ключ. Чиста функція: `platform` повертає рядок рушія або undefined.
 */
export function viewLabel(view: string, module: IModuleDefinition | undefined, strings: IModuleStrings, platform: (view: string) => string | undefined): string {
  const standard = (standardViews as readonly string[]).includes(view);
  const page = standard ? undefined : module?.pages?.find((p) => p.key === view);
  if (page) return strings.page(view, page.label);
  return (view === MESSAGE_KEY ? undefined : platform(view)) ?? view;
}
